//#region ../erd-editor-schema/dist/query/lww.js
function createLWWTuple(tag) {
	return [
		tag,
		-1,
		-1,
		{}
	];
}
function getOrCreate(lww, id, tag) {
	const value = lww[id];
	if (value) return value;
	lww[id] = createLWWTuple(tag);
	return lww[id];
}
function addOperator(lww, version, id, tag, recipe) {
	const tuple = getOrCreate(lww, id, tag);
	const prevVersion = tuple[1];
	const removeVersion = tuple[2];
	if (prevVersion < version) tuple[1] = version;
	if (removeVersion < version) recipe();
}
function removeOperator(lww, version, id, tag, recipe) {
	const tuple = getOrCreate(lww, id, tag);
	const prevVersion = tuple[2];
	const addVersion = tuple[1];
	if (prevVersion < version) tuple[2] = version;
	if (addVersion <= version) recipe();
}
function replaceOperator(lww, version, id, tag, path, recipe) {
	const tuple = getOrCreate(lww, id, tag);
	if ((tuple[3][path] ?? -1) <= version) {
		tuple[3][path] = version;
		recipe();
	}
}
//#endregion
export { addOperator, removeOperator, replaceOperator };
